
export type HeaderMatcher = {
    matcher: (currentHeader: string, allHeaders: string[], data: Record<string, string>[]) => boolean,
    label: string
}

type ValueValidator = (entry: string) => boolean

function valuesPass(data: Record<string, string>[], header: string, validators: ValueValidator[] = []): boolean {
    return validators.every(validator => data.every(row => validator(row[header])))
}

function headerWords(header: string): string[] {
    return header
        .replace(/(\p{Ll})(\p{Lu})/gu, '$1 $2')
        .toLowerCase()
        .split(/[^\p{L}\p{N}]+/u)
        .filter(word => word.length > 0)
}

export function wordMatcher(words: string[], label: string, dataValidators?: ValueValidator[]): HeaderMatcher {
    const wanted = words.map(word => word.toLowerCase())
    return {
        label: label,
        matcher: (currentHeader: string, _allHeaders: string[], data: Record<string, string>[]) =>
            headerWords(currentHeader).some(word => wanted.includes(word)) && valuesPass(data, currentHeader, dataValidators)
    }
}

function countMatches(s: string, needles: string[]): number {
    console.log(`${needles.filter(x => s.includes(x)).length} matches for ${s} in `, needles)
    return needles.filter(x => s.includes(x)).length
}

export function partialMatcher(
    requiredOptions: string[][],
    optional: string[],
    label: string,
    exclusions?: string[],
    dataValidators?: ValueValidator[],
): HeaderMatcher {
    return {
        label: label,
        matcher: (currentHeader: string, allHeaders: string[], data: Record<string, string>[]) => {
            console.log("required ones are: ", requiredOptions)
            const lower = currentHeader.toLowerCase()
            if (!requiredOptions.find(x => countMatches(lower, x.map(y => y.toLowerCase())) == x.length)) {
                console.log("found no combination of required matches", requiredOptions, lower)
                /* a required one wasn't matched */
                return false;
            }
            if (exclusions?.some(exclusion => lower.includes(exclusion))) {
              console.log("found required matches, but also an excluded value", exclusions, lower)
              return false
            }
            const optionalLower = optional.map(x => x.toLowerCase())
            const optionalMatches = countMatches(lower, optionalLower)
            return !allHeaders
                .map(x => x.toLowerCase())
                .find(x => x !== lower && countMatches(x.toLowerCase(), optional) > optionalMatches)
              && valuesPass(data, currentHeader, dataValidators);
        }
    }
}